export enum DepositStatus {
    NEW = 'new',
    COMPLETED = 'completed',
    REJECTED = 'rejected',
    RETURN_IN_PROGRESS = 'return_in_progress',
    RETURNED = 'returned'
}